const adb2cauth = async () => {
    const res = await fetch("Auth/GetAuthContext");

    if (!res.ok) {
        throw new Error("Erro ao obter AuthContext");
    }

    return await res.json();
}

export default adb2cauth; 